<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    title="微小 - 首页关注引导"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-form
      ref="RefForm"
      :model="formState"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 16 }"
    >
      <!-- 引导开关 -->
      <a-form-item
        label="引导开关"
        name="ison_guide"
      >
        <a-switch v-model:checked="formState.ison_guide" />
      </a-form-item>
      <!-- icon -->
      <a-form-item
        label="icon"
        name="cover_icon"
        :rules="[{ required: formState.ison_guide, validator: validator }]"
      >
        <!-- 上传组件 -->
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="GroupInfo"
            :imgSizeMode="3"
            :imgSizeWidth="300"
            :imgSizeHeight="300"
            imgSizeError="图片尺寸为 300 * 300"
            :beforeUploadPro="beforeUploadPro"
            :uploadResult="(fileJson, res, record) => uploadResult('cover_icon', fileJson, res, record)"
            :fileList="formState.cover_icon"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">支持.png .jpg .gif，尺寸 300x300</div>
        <div class="form-upload-list" v-if="formState.cover_icon.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.cover_icon"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('cover_icon', index)"
          >
          </ImageView>
        </div>
      </a-form-item>
      <!-- 引导图片 -->
      <a-form-item
        label="引导图片"
        name="cover_guide"
        :rules="[{ required: formState.ison_guide, validator: validator }]"
      >
        <!-- 上传组件 -->
        <a-form-item-rest>
          <Upload
            accept=".png,.jpg,.gif"
            uploadSource="GroupInfo"
            :imgSizeMode="3"
            :imgSizeWidth="630"
            :imgSizeHeight="800"
            imgSizeError="图片尺寸为 630 * 800"
            :beforeUploadPro="beforeUploadPro"
            :uploadResult="(fileJson, res, record) => uploadResult('cover_guide', fileJson, res, record)"
            :fileList="formState.cover_guide"
            :uploadBucket="$pub.BUCKET_PUB()"
          />
        </a-form-item-rest>
        <div class="form-upload-hint">支持.png .jpg .gif，尺寸 630x800</div>
        <div class="form-upload-list" v-if="formState.cover_guide.length">
          <ImageView
            class="form-upload-item"
            v-for="(item, index) in formState.cover_guide"
            :key="index"
            :url="$pub.CDN_URL(item.url)"
            :fileJson="item"
            @delete="touchDeleteCover('cover_guide', index)"
          >
          </ImageView>
        </div>
      </a-form-item>
    </a-form>
    <!-- 尾部 -->
    <template #footer>
      <a-button style="margin-right: 8px" @click="onClose">取消</a-button>
      <a-button type="primary" @click="touchSubmit">确定</a-button>
    </template>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
    <!-- 预览 -->
    <PreviewModal ref="RefPreviewModal"></PreviewModal>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import Loading from '@/components/Loading'
import Upload from '@/components/Upload'
import ImageView from '@/components/ImageView'
import PreviewModal from '@/components/preview/PreviewModal'
import Pub from '@/utils/public'
import { getLeadConfig, leadConfigSave } from '@/api/operate'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)

const emit = defineEmits('success')
// Form实例
const RefForm = ref(null)
// 视频预览
const RefPreviewModal = ref(null)
// 抽屉展示状态
let visible = ref(false)
// 加载
let isLoading = ref(false)
// 平台ID
let platformID  = ref(undefined)
// 详情ID
let id = ref(undefined)
// 信息
let formState = reactive({
  // 引导开关
  ison_guide: false,
  // 引导icon
  cover_icon: [],
  // 引导图
  cover_guide: []
})

// 打开抽屉
function showDrawer (pid, did) {
  visible.value = true
  id.value = did
  platformID.value = pid
  // 获取详情
  getDetail()
}

// 获取详情
function getDetail () {
  isLoading.value = true
  getLeadConfig({
    platform_id: platformID.value,
    type: id.value
  }).then(res => {
    isLoading.value = false
    const { code, msg, data } = res
    if (code === 0) {
      // 设置表单显示
      nextTick(() => {
        formState.num = data.num
        formState.ison_guide = data.ison_guide ? true : false
        formState.cover_icon = data.cover_icon && [data.cover_icon] || []
        formState.cover_guide = data.cover_guide && [data.cover_guide] || []
      })
    } else {
      message.error(res.message || msg)
    }
  })
}

// 关闭抽屉
function onClose () {
  if (!isLoading.value) {
    RefForm.value.resetFields()
    visible.value = false
  }
}

// 准备上传（图片）
function beforeUploadPro (file) {
  if (!file.type.includes('image')) {
    message.error('请上传图片类型的文件')
    return false
  }
  return true
}

// 上传结果
function uploadResult (key, fileJson, res, record) {
  // 上传结果判断
  if (fileJson.status === 'done') {
    RefForm.value.validate()
    formState[key] = [fileJson]
  }
}

// 图片校验
function validator (rule, value) {
  // 图片
  if (rule.field === 'cover_icon') {
    if (formState.ison_guide) {
      if (value && value.length === 0) {
        return Promise.reject('请上传')
      }
    }
    return Promise.resolve()
  }
  // 图片
  if (rule.field === 'cover_guide') {
    if (formState.ison_guide) {
      if (value && value.length === 0) {
        return Promise.reject('请上传')
      }
    }
    return Promise.resolve()
  }
  // 都通过
  return Promise.resolve()
}

// 移除封面
function touchDeleteCover (coverKey, index) {
  formState[coverKey].splice(index, 1)
}

// 提交
function touchSubmit () {
  RefForm.value.validate().then((() => {
    // 检查上传
    const imgs = (formState.cover_icon || []).concat(formState.cover_guide || [])
    const isUploadSuccess = imgs.every(item => {
      return item.status === undefined || item.status === 'done'
    })
    if (!isUploadSuccess) {
      message.error('正在上传中...')
      return
    }
    isLoading.value = true
    // 头像信息
    const cover_icon = formState.cover_icon[0]
    const cover_guide = formState.cover_guide[0]
    // 准备数据
    const params = {
      platform_id: platformID.value,
      type: id.value,
      ...formState,
      cover_icon,
      cover_guide,
      ison_guide: formState.ison_guide ? 1 : 0,
      ison_pay: formState.ison_pay ? 1 : 0
    }
    leadConfigSave(params).then(res => {
      isLoading.value = false
      const { code, msg, data } = res
      if (code === 0) {
        message.success('操作成功')
        onClose()
        emit('success')
      } else {
        message.error(res.message || msg)
      }
    })
  }))
}

// 暴露出去
defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
.a-link {
  margin-left: 8px;
}
.form-item-clear {
  margin-bottom: 0;
}
.form-upload-hint {
  padding-top: 6px;
  color: #8D8D8D;
}
.form-upload-list {
  display: flex;
  flex-wrap: wrap;
  margin-left: -10px;
}
// .form-upload-item {
//   margin-top: 10px;
//   margin-left: 10px;
//   position: relative;
//   width: 118px;
//   height: 148px;
//   border-radius: 4px;
//   overflow: hidden;
//   img {
//     display: inline-block;
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//   }
//   &.horizontal {
//     width: 148px;
//     height: 118px;
//   }
// }
.image-view.form-upload-item {
  margin-top: 10px;
  margin-left: 10px;
  width: 118px;
  height: 148px;
  &.horizontal {
    width: 148px;
    height: 118px;
  }
}
.checkbox-form {
  position: absolute;
  right: 8px;
  bottom: 18px;
  width: 14px;
  height: 14px;
  margin-bottom: 0;
}
.upload-item-select {
  
}
.date-range {
  color: #8D8D8D;
  padding-left: 100px;
  margin-top: -15px;
}
</style>